import React, {useState} from 'react';
// import logo from './logo.svg';
import './App.css';
import {Column, Row} from "./components/motion_mui";
import {Box, Typography} from "@material-ui/core";
// import {Navbar} from "./navbar/navbar";
import {Home} from "./home/home";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {useEffect} from 'react';
// import useMediaQuery from "@material-ui/core/useMediaQuery";
import useWindowDimensions from "./hooks/window";
import useDimensions from "react-cool-dimensions";
import OpenInNewOutlinedIcon from "@material-ui/icons/OpenInNewOutlined";
import {useStyles} from "./hooks/styles";
import QuestionAnswerOutlinedIcon from "@material-ui/icons/QuestionAnswerOutlined";
import MenuOutlinedIcon from '@material-ui/icons/MenuOutlined';
import {vQAndAWebWidgetCSS, vQAndAWebWidgetJS} from "./constants";
import { DataGrid } from '@mui/x-data-grid';


const useScript = (url: string) => {
    // TODO append in head
    useEffect(() => {
        const script = document.createElement('script');

        script.src = url;
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        }
    }, [url]);
};

const useCSS = (url: string) => {
    useEffect(() => {
        let link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        document.getElementsByTagName('head')[0].appendChild(link);
    }, [url])
}

// function FounderCard(props: {
//     firstname: string,
//     lastname: string,
//     linkedin: string,
//     email: string,
//     role: string,
//     education: string
// }) {
//     const [showEmail, setShowEmail] = useState(false)
//     return (
//         <Column crossAxisAlignment={"start"} mainAxisAlignment={"start"}
//                 style={{
//                     backgroundColor: "#F2F3F4",
//                     margin: "20px",
//                     padding: "20px",
//                     maxWidth: "220px",
//                     minHeight: "120px"
//                 }}>
//             <div style={{textAlign: "start"}}>{props.firstname} {props.lastname} {props.role}</div>
//             {
//                 showEmail ?
//                     <a href={"mailto:" + props.email}>{props.email}</a>
//                     :
//                     <button onClick={() => setShowEmail(true)}>Show email</button>
//             }
//             <a href={props.linkedin}>Linkedin</a>
//             <div style={{textAlign: "start"}}>{props.education}</div>
//         </Column>
//     )
// }

function Form() {
    return <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLScbLM5Nyl7PdVxZ1mbZ_xTi8vGrXqqvjoijrJnH5e6EVgycOQ/viewform?embedded=true"
        style={{
            flexGrow: 1,
            border: "none",
            width: "100%",
            height: "q00%",
        }}/>
}

function Guide() {
    useScript("https://app.qanda.link/ext/qandaWebWidget/qandaWebWidget." + vQAndAWebWidgetJS + ".js")
    useCSS("https://app.qanda.link/ext/qandaWebWidget/qandaWebWidget." + vQAndAWebWidgetCSS + ".css")
    useCSS("https://fonts.googleapis.com/icon?family=Material+Icons")
    // const theme = useTheme()
    // const matchesSMUp = useMediaQuery(theme.breakpoints.up('sm'));
    const columnDims = useDimensions()

    const windowDims = useWindowDimensions() as { width: number }
    const [windowWidth, setWindowWidth] = useState(windowDims.width)
    const matchesSMUp = windowWidth >= 600

    // const matchesSMUp = windowDims.width * 12 / 7 > 600;
    useEffect(() => {
        window.parent.postMessage({
            message: "guideHeight",
            data: columnDims.height
        }, "*")
    }, [columnDims.height])

    useEffect(() => {
        const messageHandler = (event: MessageEvent) => {
            if (event.data.message === "setWindowWidth") {
                setWindowWidth(event.data.data)
            }
        }
        window.addEventListener("message", messageHandler, false)
        return () => {
            window.removeEventListener("message", messageHandler);
        }
    }, [])

    const classes = useStyles()

    return (
        <Column ref={columnDims.observe} style={{
            maxWidth: "100%",
            height: "100%",
            padding: matchesSMUp ? "64px 64px" : "32px 32px",
        }} mainAxisAlignment={"start"} crossAxisAlignment={"start"}>
            <Typography variant={"h5"}>
                Demo - qanda is enabled in this window
            </Typography>
            <Box height={"32px"}/>
            <Typography variant={"h3"}>
                Qanda Guide
            </Typography>
            <Box height={"24px"}/>
            <Typography variant={"body1"}>
                Text selections that are linked to questions are highlighted and followed by <QuestionAnswerOutlinedIcon
                className={classes.inlineIcon}/>.
                Questions with accepted answers are highlighted in green, whereas questions without a satisfactory
                answer are highlighted in red.
                Click on <QuestionAnswerOutlinedIcon className={classes.inlineIcon}/> to open the qanda pop-up window
                with answers and comments.
            </Typography>
            <Box height={"16px"}/>
            <Typography variant={"body1"}>
                Anyone can improve questions and answers through our proposal mechanism. An edit is first displayed as a
                proposal. Once a proposal receives 10 up-votes the changes will be applied to the question or
                answer.
            </Typography>
            <Box height={"16px"}/>
            <Typography variant={"body1"}>
                Press on <MenuOutlinedIcon className={classes.inlineIcon}/> to reach the question overview. Here you
                also have the option to choose if you want to receive notifications when new questions are posted on the
                web page.
            </Typography>
            <Box height={"16px"}/>
            <Typography variant={"body1"}>
                Qanda works inside PDF files, too! <a href={"/assets/pdf/deeper_learning.pdf"}>PDF links</a> are wrapped
                with a <OpenInNewOutlinedIcon className={classes.inlineIcon}/> button that opens the qanda PDF viewer.
            </Typography>
            <Box height={"16px"}/>
            <Typography variant={"body1"}>
                For more info see <a href={"/"}>qanda.link</a>. Thank you for using qanda!
            </Typography>
        </Column>
    )
}


const columns = [
    {
        field: 'name',
        headerName: 'name',
        width: 150,
    },
    {
        field: 'data',
        headerName: 'Personal data',
        width: 150,
    },
    {
        field: 'usage',
        headerName: 'How we use your data',
        width: 300,
    },
];

const rows = [
    {
        id: 'auth',
        name: 'Firebase Authentication (Signup/Login)',
        data: 'Passwords\n' +
            'Email addresses\n' +
            'Phone numbers\n' +
            'User agents\n' +
            'IP addresses',
        usage: 'How it helps: Firebase Authentication uses the data to enable end-user authentication, and facilitate end-user account management. It also uses user-agent strings and IP addresses to provide added security and prevent abuse during sign-up and authentication.\n' +
            '\n' +
            'Retention: Firebase Authentication keeps logged IP addresses for a few weeks. It retains other authentication information until the Firebase customer initiates deletion of the associated user, after which data is removed from live and backup systems within 180 days.'
    },
];


function PrivacyCard(props: {
    title: string,
    data: string[],
    usage: string,
    retention: string,
}) {
    return (
        <Column mainAxisAlignment={"start"} crossAxisAlignment={"stretch"} style={{
            marginTop: "56px"
        }}>
            <Typography variant={"h4"}>
                {props.title}
            </Typography>

            <Box height={"24px"}/>
            <Typography variant={"h5"}>
                Data
            </Typography>
            <Row style={{
                flexGrow: 1,
                overflowX: "hidden",
                flexWrap: "wrap"
            }} mainAxisAlignment={"start"} crossAxisAlignment={"start"}>
                {
                    props.data.map((data, idx) => {
                        return (
                            <div style={{
                                backgroundColor: "#F0F3F4",
                                marginRight: idx === props.data.length - 1 ? "0px" : "12px",
                                marginTop: "6px",
                                padding: "0 6px",
                                borderRadius: "4px",
                                whiteSpace: "nowrap"
                            }}>
                                <Typography variant={"body2"}>
                                    {data}
                                </Typography>
                            </div>
                        )
                    })
                }
            </Row>

            <Box height={"16px"}/>
            <Typography variant={"h5"}>
                Usage
            </Typography>
            <Box height={"6px"}/>
            <Typography variant={"body2"}>
                {props.usage}
            </Typography>

            <Box height={"12px"}/>
            <Typography variant={"h5"}>
                Retention
            </Typography>
            <Box height={"6px"}/>
            <Typography variant={"body2"}>
                {props.retention}
            </Typography>
        </Column>
    )
}

// https://firebase.google.com/support/privacy
function Privacy() {
    const windowDims = useWindowDimensions() as { width: number }
    const [windowWidth, setWindowWidth] = useState(windowDims.width)
    const paddingTop = Math.min(windowDims.width*windowDims.width / (2500*2500), 1) * 200 + 20
    return (
        <Column mainAxisAlignment={"start"} crossAxisAlignment={"center"} style={{
            padding: paddingTop + "px 20px"
        }}>
            <Column mainAxisAlignment={"start"} crossAxisAlignment={"start"} style={{
                maxWidth: "900px"
            }}>
                <Typography variant={"h1"}>
                    Qanda.link Privacy Policy
                </Typography>
                <Box height={16}/>
                <Typography variant={"body1"}>
                    This document outlines what data we collect about you and how we use that data.
                    We may change our policies from time to time and will notify you by email or other means if the changes are material.
                    If you disagree with our policies, you have to stop using qanda.link and delete your account under "Account/Profile".
                    If in doubt, do not hesitate to email us at privacy@qanda.link.
                </Typography>
                <PrivacyCard
                    title={"User Generated Data"}
                    data={["Questions", "Answers", "Proposals", "Comments", "Likes (or votes, reactions)", "Library"]}
                    usage={"We use this data to provide you with the features of qanda.link. You can view most of your activities under \"Account/Activity\"."}
                    retention={"You have to manually delete your data. For example, in order to delete a question click \"more\" and then \"delete\"."}
                />
                <PrivacyCard
                    title={"User Statistics"}
                    data={["Viewed questions", "Last sign in"]}
                    usage={"These user statistics give us the necessary insights to improve our services and obtain funding."}
                    retention={"You have to delete your account to delete any user statistics associated with your account."}
                />
                <PrivacyCard
                    title={"Firebase Authentication"}
                    data={["Passwords", "Email addresses", "User agents", "IP addresses"]}
                    usage={"Firebase Authentication uses the data to enable end-user authentication, and facilitate end-user account management. It also uses user-agent strings and IP addresses to provide added security and prevent abuse during sign-up and authentication."}
                    retention={"Firebase Authentication keeps logged IP addresses for a few weeks. It retains other authentication information until the Firebase customer initiates deletion of the associated user, after which data is removed from live and backup systems within 180 days."}
                />
                <PrivacyCard
                    title={"Firebase Cloud Messaging"}
                    data={["Firebase installation IDs"]}
                    usage={"Firebase Cloud Messaging uses Firebase installation IDs to determine which devices to deliver messages to."}
                    retention={"Firebase retains Firebase installation IDs until the Firebase customer makes an API call to delete the ID. After the call, data is removed from live and backup systems within 180 days."}
                />
                <PrivacyCard
                    title={"Firebase Hosting"}
                    data={["IP addresses"]}
                    usage={"Hosting uses IP addresses of incoming requests to detect abuse and provide customers with detailed analysis of usage data."}
                    retention={"Hosting retains IP data for a few months."}
                />
            </Column>
        </Column>
    )
}


function App() {
    return (
        <Router>

            <Switch>
                <Route path={"/privacy-policy"}>
                    <Privacy/>
                </Route>
                <Route path={"/form"}>
                    <Form/>
                </Route>
                <Route path={"/guide"}>
                    <Guide/>
                </Route>
                <Route path={"/"}>
                    <Home/>
                </Route>
            </Switch>
        </Router>
    );
}

export default App;
